import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1PortfoliosEdit } from "./edit";
import { D1PortfoliosNew } from "./new";
import { D1PortfoliosTable } from "./table";
export default function D1Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1PortfoliosEdit />} />
      <Route index element={<D1PortfoliosTable />} />
      <Route path="/new" element={<D1PortfoliosNew />} />
    </Routes>
  );
}
